/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CountryResponse } from '../../models/country-response';

export interface CountryControllerGetAll$Params {
  query?: string;
  popular?: boolean;
}

export function countryControllerGetAll(http: HttpClient, rootUrl: string, params?: CountryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, countryControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('popular', params.popular, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CountryResponse;
      }>;
    })
  );
}

countryControllerGetAll.PATH = '/country';
